"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
function WarningBlock(_a) {
    var children = _a.children;
    return (react_1.default.createElement(Wrapper, null,
        react_1.default.createElement(core_ui_1.Padding, { x: 56, y: 48 },
            react_1.default.createElement("svg", { width: "20", height: "20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                react_1.default.createElement("path", { d: "M19.02 16.911L11.103 2.067a1.25 1.25 0 00-2.207 0L.98 16.911a1.25 1.25 0 001.104\n            1.839h15.834a1.25 1.25 0 001.102-1.839zM10 16.25a1.25 1.25 0 11.001-2.5 1.25 1.25 0\n            010 2.5zm1.25-3.75h-2.5v-5h2.5v5z", fill: "#546A83" })),
            children)));
}
exports.default = WarningBlock;
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border-radius: 3px;\n  text-align: center;\n"], ["\n  background-color: ", ";\n  border-radius: 3px;\n  text-align: center;\n"])), core_ui_1.colors.steel[100]);
var templateObject_1;
